module.exports = __webpack_public_path__ + "static/favicon-5aa70194e036cf87b52f8f2578c0c403.png";